import { MLM, MsTracking, NOT_SET, TrackingParameter, createTealiumTracking } from '@sunrise/tracking'

import { Bookmark } from '../../ts/mapper/bookmarkMapper.interface'
import { ActionIds, MLMData } from '../../ts/tracking/mlmActionIds.enum'
import { staticMlmTrackingData } from '../../ts/tracking/mlmStaticTrackingData'
import { TealiumTrackingIds } from '../../ts/tracking/tealiumTrackingIds.enum'
import { getCompanyName, getPositionAsString, getTypePaid, getVariant } from '../../ts/utils/trackingUtils'
import { BookmarkListAction, BookmarkListBodyType } from '../../ts/utils/trackingUtils.enum'

const bookmarkRemoveBaseData: TrackingParameter = {
    mslayer_element_data_id: TealiumTrackingIds.BOOKMARK_LIKE_AND_REMOVE_AND_REVERT_CLICK,
    mslayer_element_type_text: 'Merkliste',
    mslayer_element_count: NOT_SET,
    mslayer_element_variant: 'default',
    mslayer_element_position: NOT_SET,
    mslayer_element_detail_start_date: NOT_SET,
}

export function buildTealiumRemoveBookmarkData(bookmark: Bookmark, ownInventory: boolean) {
    return {
        ...bookmarkRemoveBaseData,
        mslayer_element_body_type: BookmarkListBodyType.BODY,
        mslayer_element_company_name: getCompanyName(ownInventory),
        mslayer_element_id: bookmark.guid,
        mslayer_element_text: BookmarkListAction.REMOVE,
    }
}

export function getTrackingDataForItem(
    item: Bookmark,
    componentId: string,
    currentUrl: string,
    position: number,
    ownInventory: boolean,
): MsTracking[] {
    return [
        buildTealiumTrackingData(item, position, ownInventory),
        buildMlmTrackingData(item, componentId, currentUrl, position, ownInventory),
    ]
}

function buildTealiumTrackingData(item: Bookmark, position: number, ownInventory: boolean): MsTracking {
    return createTealiumTracking({
        mslayer_element_body_type: 'list',
        mslayer_element_company_name: getCompanyName(ownInventory),
        mslayer_element_count: NOT_SET,
        mslayer_element_data_id: TealiumTrackingIds.BOOKMARK_ITEM_CLICK,
        mslayer_element_detail_start_date: item.createdDateFormatted,
        mslayer_element_id: item.guid,
        mslayer_element_position: getPositionAsString(position),
        mslayer_element_text: item.title,
        mslayer_element_type_text: NOT_SET,
        mslayer_element_variant: getVariant(item.newestEstate),
    })
}

function buildMlmTrackingData(
    item: Bookmark,
    componentId: string,
    currentUrl: string,
    position: number,
    ownInventory: boolean,
): MsTracking {
    return MLM.createMlmTracking({
        ...staticMlmTrackingData,
        page: MLMData.DEFAULT_PAGE as number,
        actionId: ActionIds.BOOKMARK_ITEM_CLICK,
        componentId,
        pageUrl: currentUrl,
        items: [buildMlmItem(item, ownInventory, position)],
    })
}

function buildMlmItem(item: Bookmark, ownInventory: boolean, position: number): MLM.Item {
    return {
        id: item.guid,
        type: getCompanyName(ownInventory),
        typePaid: getTypePaid(ownInventory),
        typePosition: position,
    }
}
